import root from './_root.js';

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

export default coreJsData;



//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/lodash-es/_coreJsData.js
// module id = 430
// module chunks = 0 1 2 3 4 5 6 7 8 9 10